import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";

interface IBlockProps {
    title: string;
    description?: string;
    children?: React.ReactNode;
}

const Block = styled.div`
    height: 340px;
    border: 1px solid #F1F2FE;
    border-radius: 16px;
    padding: 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    @media only screen and (min-width : 768px) {
        width: 384px;
    }
`;

const BlockTitle = styled.div`
    font-size: 20px;
    font-weight: 500;
    color: #363870;
    margin-bottom: 8px;
    line-height: 24px;
`;

export default observer(function(props: IBlockProps) {
    return (
        <Block>
            <BlockTitle>{props.title}</BlockTitle>
            {props.children}
        </Block>
    );
});